module.exports = __webpack_public_path__ + "assets/img/8_1760.2474ec27.jpg";